import styled from 'styled-components';

export const Box = styled.div`
	position: relative; /* Ustawiamy pozycję na relative */
	width: 160px;
	height: 160px;
	border-radius: 8px; /* Zaokrąglenie krawędzi */
	background-color: white !important;
	box-shadow: 0px 0px 11px 0px rgba(79, 167, 180, 0.2);
`;

export const ImageWrapper = styled.div`
	width: 160px;
	height: 160px;
	position: relative; /* Ustawiamy pozycję na relative */
	overflow: hidden;

	img {
		border-radius: 8px;
		width: 100%;
		height: 100%;
	}
`;

export const ImageOverlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(41, 24, 94, 0.5); /* Kolor nakładki */
	border-radius: 8px; /* Zaokrąglenie krawędzi */
`;

export const Heart = styled.div`
	position: absolute;
	right: 8px;
	top: 8px;
	width: 25px;
	z-index: 2;

	img {
		width: 100%;
		height: auto;
	}
`;

export const Checkmark = styled.div`
	position: absolute;
	right: 8px;
	bottom: 8px;
	width: 25px;
	height: 25px;
	z-index: 2;
`;

export const TopTitle = styled.div`
	color: #fff;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 123.5%; /* 24.7px */
	letter-spacing: 0.4px;
	position: absolute;
	color: white;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1;

	div {
		max-width: 130px;
	}
`;
